// https://stackoverflow.com/questions/48759538/do-you-need-to-unsubscribe-from-output-eventemitter // we don't need to unsubscribe from input/output variables

import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { Router, RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { RouteDataService } from '@app/services/route-data.service';
import { HttpService } from './services/http.service';
import { environment } from '@env/environment';
import { tap, shareReplay } from 'rxjs/operators';
import { Code } from '@app/models/code'; 
import { Status } from '@app/models/status';
import { AuthService } from './services/auth.service';
import { Physician } from './models/physician';
import { ThemingService } from './services/theming.service';
import { Hospital } from './models/hospital';
import { ChartUploadService } from './services/chartUpload.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  showOverlay: boolean = false; //
  previousUrl: string = null;
  currentUrl: string = null;

  public constructor( 
    private titleService: Title,
    private router: Router,
    private routeDataService: RouteDataService,
    private httpService: HttpService,
    private authService: AuthService,
    private themingService: ThemingService,
    private chartUploadService: ChartUploadService // Loaded here to immediately start uploading pending stuff
  ){
    // set this initial title
    this.setTitle( themingService.getOrganizationName() );

    // set up listening on router
    router.events.subscribe(( event: RouterEvent ) => {
      this.navigationInterceptor( event );
    });    
  }

  // handle lifecycle events from the router
  private navigationInterceptor( event: RouterEvent ):void {

    const urlLogin = this.router.createUrlTree([
      'account',
      'login'
    ]).toString();
    
    if( event instanceof NavigationStart ){
      // this.showOverlay = true;
    } else if ( event instanceof NavigationEnd ){
      // this.showOverlay = false;
    } else if ( event instanceof NavigationCancel ){
      // this.showOverlay = false;
    } else if ( event instanceof NavigationError ){
      // this.showOverlay = false;
    }
  }

  // respond after angular checks the content projected into the directive or component.
  ngAfterContentInit() {

    this.authService.isAuthenticated$.subscribe(result => {
      if ( result === true ) {
        // initialize static content
        this.routeDataService.loadAndCache<Code>('codes', ['api', 'codes'], { is_active: true }).subscribe();
        this.routeDataService.loadAndCache<Status>('statuses', ['api', 'statuses']).subscribe();
        this.routeDataService.loadAndCache<Hospital>('hospitals', ['api', 'hospitals']).subscribe();
        this.routeDataService.loadAndCache<Physician>('physicians', ['api', 'physicians']).subscribe();
      } else {
        // not authorized
      }
    });
  }
  
  // Called once, after the first ngOnChanges()
  ngOnInit(){
    // handle routing events  
    this.router.events.pipe(
      filter(( event ) => event instanceof NavigationEnd ),
      tap( _ => null )
    ).subscribe(( event:NavigationEnd ) => {
      this.routeDataService.setPreviousUrl( this.currentUrl );
      this.currentUrl = event.url;
    });

    this.initializeUserMonitoring();
  }

  // monitor user authentication, if user loses authentication, route to the login screen
  private initializeUserMonitoring(): void {
    // route users to login page if not authenticated 
    this.authService.isAuthenticated$.pipe(
      // first( value => value === false ) // this doesn't work when you click the logout link
    ).subscribe( value => {
      if( value === false )
      {
        this.navigateToLogin();
      }
    });
  }

  // navigate to the login screen
  navigateToLogin(): void {
    const urlLogin = this.authService.getUrlLogin();
    this.router.navigateByUrl( urlLogin );
  }

  setTitle( newTitle: string ){
    this.titleService.setTitle( newTitle );
  }

  getTitle(): string {
    return this.titleService.getTitle();
  }

  resetSiteTitle()
  {
    this.setTitle( this.themingService.getOrganizationName() );
  }

  appendSiteTitle( ...titles: string[] ): string
  {
    // set this back to base value
    this.resetSiteTitle(); 

    let existingTitles: string[] = this.titleService.getTitle().split(' | ');
    existingTitles = [ ...existingTitles, ...titles ];
    let title = existingTitles.join(' | ');
    this.setTitle( title );
    return this.getTitle();
  }

}
